var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "23 1 97 120"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.61 21.3L99.29 2A3.23 3.23 0 0097 1.07H49.83a2.43 2.43 0 00-2.14 2.29v24.5H24.94a2.46 2.46 0 00-2.14 2.29v88.56a2.47 2.47 0 002.29 2.29h67.33a2.49 2.49 0 002.37-2.37V94.2h22.52a2.48 2.48 0 002.37-2.36V23.28a2.89 2.89 0 00-1.07-1.98zM99.6 9l12.06 11.83H99.6zm-9.47 107.34h-62.6V32.52H70v17.56a2.48 2.48 0 002.37 2.36h17.76zm-15.42-68.7V35.8l12.06 11.84zM115 89.55H94.79V50.08a2.89 2.89 0 00-1.07-2l-19.31-19.3a3.24 3.24 0 00-2.29-.92h-19.7V5.72h42.45v17.56a2.48 2.48 0 002.36 2.37H115z",
    fill: "#707070"
  })));
}

export default __webpack_public_path__ + "static/media/copy.77f49e593b3964f7f7fab4a0931e2b55.svg";
export { SvgCopy as ReactComponent };